import { has, merge, set } from 'lodash';
import { TableColumn, ColumnDef, ColumnMeta, TableMeta } from '..';
import { getColumnCellType } from '.';

/**
 * This method constructs column info based on columnOverride
 * @param col column information
 * @param data data for table
 * @param columnOverride column info that will override default
 * @param tableOptions options for table
 * @returns column info object
 */
export const getColumnDefWithPresets = <TData>(
  col: TableColumn<TData>,
  data: TData[],
  columnOverride?: Partial<ColumnDef<TData>>,
  tableOptions?: Partial<TableMeta>,
): TableColumn<TData> => {
  const colDef = columnOverride ? merge({}, columnOverride, col) : col;

  // set cellType
  if (!has(colDef, 'cellType')) {
    colDef.cellType = getColumnCellType<TData>(colDef.colId, data);
  }

  // set valueFormatterOptions.enabled
  if (!has(colDef, 'valueFormatterOptions.enabled')) {
    set(colDef, 'valueFormatterOptions.enabled', tableOptions?.enableValueFormatting ?? true);
  }

  return colDef;
};
